<template>
    <div class="forgot-password">
        <h3 class="def-title-3">
            <span v-if="!isErrors" class="forgot-password__title enter__active">
                {{ obData.messages.forgot_password }}
            </span>
        </h3>
        <p v-if="!changePassword"
            class="forgot-password__text"
        >
            {{ obData.messages.putEmail }}
        </p>

        <!--            Вывод системных ошибок восстановления пароля если существуют-->
        <div v-if="obData.authInfo.errors" class="forgot-password__errors">
            <span v-for="error in obData.authInfo.errors.system_errors">{{error}}</span>
        </div>
        <div>
            <form @submit.prevent="forgotPassword($event)"
                  class="forgot-password__tab form-vertical"
                  v-if="!changePassword"
            >

                <def-email
                        name="USER_EMAIL"
                        :label="obData.placeholder.email"
                        maxlength='255'
                        :required="true"
                />
                <div v-for="input in obData.forgotPasswordInputs">
                    <input
                        v-if="input.type !== 'submit' && input.name !== 'USER_PHONE_NUMBER' && input.name !== 'USER_LOGIN'"
                        :required="input.type !== 'hidden'"
                        :placeholder="input.placeholder"
                        :name="input.name"
                        :type="input.type"
                        :value="input.value">
                    <div class="form-vertical-buttons__forgot-password " v-else-if="input.type === 'submit'">
                        <button
                            :type="input.type"
                            :name="input.name"
                            class="def-button"
                        >
                            {{ obData.messages.send }}
                        </button>
                    </div>
                </div>
            </form>
            <div v-else-if="!isErrors"
                class="forgot-password__send-mail"
            >
                <p v-if="messages" class="forgot-password__text">
                    {{ messages.sendOnYourEmail }}
                </p>
                <button
                    type="submit"
                    class="def-button"
                    @click="closeModal"
                >
                    {{ obData.messages.ok }}
                </button>
            </div>
        </div>
    </div>
</template>


<script>

import {mapMutations, mapState} from 'vuex';

    export default {
        name: 'forgot-password',
        selector: '.forgot-password',
        props: ['result'],
        data (){
            return {
                activeTab: 'forgot',
                changePassword: false,
                messages: {},
                // btnValues: {
                //     send: "Отправить",
                // }
            }
        },
        computed: {
            ...mapState({
                obData: ({ personal }) => personal.data,
            }),
            isErrors() {
                return !!this.obData?.authInfo?.errors?.system_errors?.length;
            },
        },

        methods: {
            ...mapMutations({
                clearState: 'personal/clearState',
            }),
            closeModal: function(){
                this.$DefModal.hide();
                this.changePassword = !this.changePassword
            },
            async forgotPassword(e) {
                try {
                    const data = new FormData(e.target);
                    const path = this.obData?.actions?.forgot_password;
                    const {data: {action, api, LANGUAGE_ID}} = this.obData?.routes?.forgot_password;

                    data.append('api', api);
                    data.append('action', action);
                    data.append('action', action);
                    data.append('LANGUAGE_ID', LANGUAGE_ID);

                    const response = await axios.post(path, data);

                    if ( response.status === 200 && response.data.authInfo ) {
                        this.$store.commit('personal/updateData', {name: 'forgotPasswordInputs', data: response.data.forgotPasswordInputs});
                        this.$store.commit('personal/updateData', {name: 'authInfo', data: response.data.authInfo});
                        //подтверждающее окно после успешной отправки запроса
                        this.changePassword = true;

                        this.messages = response.data.messages;
                    }
                    // console.log(response);

                    if ( response.data.changePasswordStatus ) {
                        this.openChangePasswordForm(response.data);
                    }


                } catch (err) {
                    console.error(err)
                }

            },
            openChangePasswordForm(result) {
                this.$DefModal.show({
                    name: 'change-password',
                    props: {
                        width: '440px',
                        result,
                    }
                });
            },

            async getComponentData() {

                const {path, data: {action}} = this.obData?.routes?.forgot_password;
                const response = await axios.post(path, {
                    api: 'y',
                    action
                });
                this.$store.commit('personal/updateData',
                    {
                        name: 'forgotPasswordInputs', data: response.data.forgotPasswordInputs
                    });
            },

            clearErrors(){
                const data = { ...this.obData.authInfo, errors: null }
                this.$store.commit('personal/updateData', { name: 'authInfo', data });

            }
        },

        mounted() {
            this.getComponentData();
            this.clearErrors();
        },
        beforeDestroy() {
            this.clearState();
        }
    }
</script>

<style lang="scss" scoped>
    .forgot-password {
        display: flex;
        flex-direction: column;
        max-width: 440px;
        background-color: #ffffff;
        height: 100vh;
        @include point-md{
            height: 100%;
        }
        &-close {
            align-self: flex-end;
            cursor: pointer;

            svg {
                fill: #85898B;
                width: 20px;
                height: 20px;
            }
        }
        &__errors{
            display: flex;
            flex-direction: column;
            align-items: center;
            color: red;
        }
        &__text{
            font-size: rem(14);
            line-height: 16px;
            text-align: center;
        }

        &__tab{
            margin-top: 32px;
        }

        &__nav {
            display: flex;
            border: 1px solid #f5f5f5;
            height: 40px;
            margin-bottom: 20px;

            & > div {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 50%;
                pointer-events: auto;
                font-size: rem(14);
                @include point-md {
                    font-size: rem(12);
                }
                @include point-lg {
                    font-size: rem(14);
                }

                &:hover {
                    cursor: pointer;
                }
            }

            .enter__active {
                background-color: #f5f5f5;
                //pointer-events: none;
            }
        }


        .def-title-3 {
            text-align: center;
            font-size: rem(16);
            & > *:not(.enter__active) {
                display: none;
            }
        }

        .def-button {
            font-size: rem(14);
            padding: 17px 61px;
            border:  none;
            width: 100%;
            @include point-lg {
                font-size: rem(16);
            }
        }

        ::v-deep {
            .def-input {
                font-size: rem(14);
            }
            .def-email{
                margin-bottom: 20px;
            }
        }
        &__link{
            font-size: rem(14);
            line-height: 18px;
            color: #53595C;
            border-bottom: 1px dotted #53595C;
            font-family: Roboto, sans-serif;
            letter-spacing: 0.08em;
            @include point-md{
                font-size: rem(16);
                line-height: 20px;
            }
        }
        &__send-mail{
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 90%;
            margin: 0 auto;
            button{
                width: 50%;
                margin-top: 32px;
            }
        }
    }

</style>